module.exports = __webpack_public_path__ + "static/media/financial-worries-large.e65397df.png";